var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReplicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0V2.99999V6.59716V6.65687V9.52765V10.3137H7.36717H7.90103L5.93817 12.2767L6.35665 12.6949L6.77513 13.1131L7.30423 12.5839L10.1667 9.72144L8.1596 7.71909C7.46938 7.03048 7.28227 6.84754 7.12331 6.69212C7.02805 6.59898 6.9429 6.51573 6.76563 6.33945L6.35191 6.75285L5.93817 7.16628L7.90103 9.12925H1.69431V7.19431V1.19431H7.69431H13.6943V0.597156V0H7.09716H0.5ZM3.46999 2.96999C3.4645 2.97547 3.4598 4.80367 3.45806 7.33333H4.65166V4.15166H9.97867H15.3057V9.47867V14.8057H9.97867H4.65166V12H3.45735V16H9.97867H16.5V9.47867V2.95735H9.99132C6.41153 2.95735 3.47693 2.96303 3.46999 2.96999Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReplicate);
export default __webpack_public_path__ + "static/media/icon--replicate.159b8f824060fa06d58dfa4b607a3589.svg";
export { ForwardRef as ReactComponent };